<template>
  <Modal
    :active="isOpen"
    title="Histórico de Alterações"
    @close="closeModal"
    id="auto-anual-rules-history-modal"
    data-testId="auto-anual-rules-history-modal"
  >
    <div class="modal-content no-scroll-x">
      <p v-if="isLoading" data-testId="auto-anual-rules-history-loading">Carregando...</p>

      <template v-else>
        <vs-table
          v-if="historyData.length"
          :data="historyData"
          class="history-table"
          data-testId="auto-anual-rules-history-table"
        >
          <template slot="thead">
            <vs-th>Data Alteração</vs-th>
            <vs-th>Responsável</vs-th>
            <vs-th>Campo</vs-th>
            <vs-th>Valor Anterior</vs-th>
            <vs-th>Novo Valor</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              v-for="(row, index) in data"
              :key="index"
              :data-testId="`auto-anual-rules-history-row-${index}`"
            >
              <vs-td class="w-2/12">{{ formatDate(row.createdAt) }}</vs-td>
              <vs-td class="w-2/12">{{ row.user }}</vs-td>
              <vs-td class="w-2/12">{{ getFieldLabel(row.field) }}</vs-td>
              <vs-td class="w-3/12">{{ formatValue(row.field, row.oldData) }}</vs-td>
              <vs-td class="w-3/12">{{ formatValue(row.field, row.newData) }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <p v-else data-testId="auto-anual-rules-history-empty">Nenhum dado encontrado.</p>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';
import autoApi from '../../../../../services/auto.api';
import functions from '../../../../../utils/functions';

export default {
  name: 'AutoAnualRulesHistoryModal',
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      historyData: [],
      isLoading: false,
      fieldLabels: {
        coverageMaxRcf: 'Soma máxima do LMI dos RCFs',
        statesAllowed: 'Estados de pernoite aceitos',
      },
    };
  },
  watch: {
    isOpen(opened) {
      if (opened) {
        this.fetchHistory();
      } else {
        this.historyData = [];
      }
    },
  },
  methods: {
    async fetchHistory() {
      this.isLoading = true;
      try {
        this.historyData = (await autoApi.getCompanyRulesHistory()) || [];
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Erro ao carregar histórico de alterações.',
          color: 'danger',
        });
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.historyData = [];
      this.$emit('close');
    },
    getFieldLabel(field) {
      return this.fieldLabels[field] || field;
    },
    formatValue(field, value) {
      if (value === null || value === undefined || value === '') return '—';

      if (field === 'coverageMaxRcf') {
        return this.$options.filters.currency(Number(value));
      }

      if (field === 'statesAllowed') {
        try {
          return JSON.parse(value).split(',').join(', ');
        } catch {
          return value;
        }
      }

      return value;
    },
    formatDate(isoDate) {
      const spDate = new Date(isoDate).toLocaleString('sv-SE', {
        timeZone: 'America/Sao_Paulo',
      });
      return functions.formataDataHoraPadraoBR(spDate, true);
    },
  },
};
</script>

<style>
#auto-anual-rules-history-modal.con-vs-popup .vs-popup {
  min-width: 880px;
  max-width: 1200px;
  width: auto;
}
.no-scroll-x {
  overflow-x: hidden;
}
.history-table {
  width: 100%;
  table-layout: fixed;
}
.history-table td,
.history-table th {
  white-space: normal;
  word-break: break-word;
}
</style>
